<div tabindex="0" class="me-set-password">
    <div class="me-set-password__header">
        {{ 'Almost done! Now set your password.' | translate}}
    </div>
    <form [formGroup]="form">
        <div class="row">
            <div class="col-xs-12">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.password.valid
                    || (form.controls.password.pristine && !submitted))">
                        <label class="me-form-input__label">{{'Password' | translate}}*</label>
                        <input formControlName="password" [attr.type]="hidePassword ? 'password' : 'text'" class="me-form-input__input" />
                        <div class="show-password" (click)="hidePassword = !hidePassword">
                            <i class="far fa-eye" *ngIf="hidePassword"></i>
                            <i class="far fa-eye-slash" *ngIf="!hidePassword"></i>
                        </div>
                    </div>
                    <small [hidden]="form.controls.password.valid
                    || (form.controls.password.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'The password must be at least 8 characters' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-12 me-set-password__required">
                *{{ 'Required field' | translate}}
            </div>
            <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                <span class="fas fa-exclamation-circle" aria-hidden="true"></span>{{ errorMessage | translate }}
            </div>
        </div>
    </form>
    <div class="me-set-password__button">
        <button class="btn btn--primary" [class.disabled]="!form.valid" (click)="submit(form.value, form.valid)">
            {{'Next' | translate}}
        </button>
    </div>
</div>